// Generated using typescript-generator version null on 2017-10-04 16:34:56.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export class SaveCanalNotificationDto implements Dto {
  id?: number;
  nom?: string;
  code?: string;
  description?: string;
  actif?: boolean;
  autoSubscribe?: boolean;
  obligatoire?: boolean;
  avecConfirmation?: boolean;
  typeDiffusion?: TypeDiffusionEnum;
  tags?: string[];
  typeAutorisation?: TypeAutorisationEnum;
  image?: CreateRessourceMultimediaDto;
  counted?: boolean;
}

export class CanalNotificationDto implements Dto {
  id?: number;
  nom?: string;
  code?: string;
  description?: string;
  actif?: boolean;
  autoSubscribe?: boolean;
  obligatoire?: boolean;
  avecConfirmation?: boolean;
  typeDiffusion?: TypeDiffusionEnum;
  tags?: string[];
  typeAutorisation?: TypeAutorisationEnum;
  imageId?: number;
  counted?: boolean;
}

export class SaveMessageNotificationDto implements Dto {
    titre?: string;
    description?: string;
    correspondant?: string;
    url?: string;
    canalId?: number;
    miseEnAvant?: boolean;
    module?: string;
    from?: string;
    to?: string;
}

export class IdsDto implements Dto {
  ids?: number[];
}

export class MessageNotificationDto implements Dto {
  id?: number;
  titre?: string;
  description?: string;
  datePublication?: any;
  correspondant?: string;
  url?: string;
  canal?: CanalNotificationDto;
  readers?: MessageNotificationReaderDto[];
}

export class PaginateSearchDto<T> {
  pageIndex?: number;
  nbrElementsPage?: number;
  tri?: T;
  asc?: boolean;
}

export class MessageNotificationSearchCriteria extends PaginateSearchDto<MessageNotificationTriEnum> {
  notification?: string;
  read?: boolean;
  userReader?: string;
  canauxObligatoires?: boolean;
  canauxActifs?: boolean;
  canalIds?: number[];
  typeDiffusions?: boolean;
  tags?: string[];
  autorisations?: boolean;
  autorisationCorrespondants?: string[];
  messageCorrespondants?: string[];
  datePublicationMin?: any;
  datePublicationMax?: any;
}

export class Response implements AutoCloseable {
  mediaType?: MediaType;
  metadata?: any;
  entity?: any;
  length?: number;
  language?: Locale;
  location?: URI;
  lastModified?: Date;
  date?: Date;
  headers?: any;
  statusInfo?: StatusType;
  status?: number;
  allowedMethods?: string[];
  cookies?: { [index: string]: NewCookie };
  entityTag?: EntityTag;
  links?: Link[];
  stringHeaders?: any;
}

export class CorrespondantDetailsDto {
  code?: string;
  nom?: string;
  adressePrincipale?: AdresseDto;
  adresseLivraison?: AdresseDto;
  telephone?: string;
  fax?: string;
  email?: string;
  numFiness?: string;
  numAdeli?: string;
  codeRpps?: string;
  typeCarte?: string;
  correspondantParent?: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export class CreateRessourceMultimediaDto implements Dto {
  name?: string;
  mimeType?: string;
  size?: number;
  content?: string;
}

export interface Dto {
}

export class MessageNotificationReaderDto implements Dto {
  userReader?: string;
  dateLecture?: any;
}

export class CanalNotificationWithMessageCountDto extends CanalNotificationDto {
  count?: number;
}

export class CanalNotificationWithSubscribeInformationDto extends CanalNotificationDto {
  subscribed?: boolean;
}

export class PaginationResult<T> {
  pageIndex?: number;
  totalPages?: number;
  totalElements?: number;
  results?: T[];
}

export class MessageNotificationLightDto implements Dto {
  id?: number;
  titre?: string;
  description?: string;
  correspondant?: string;
  datePublication?: any;
  canalNom?: string;
  canalId?: number;
  canalImageId?: number;
  counted?: boolean;
  canalAvecConfirmation?: boolean;
  read?: boolean;
  nbrReaders?: number;
}

export class MediaType {
  type?: string;
  subtype?: string;
  parameters?: { [index: string]: string };
  wildcardType?: boolean;
  wildcardSubtype?: boolean;
}

export class Locale {
}

export class URI {
}

export interface StatusType {
  family?: Family;
  statusCode?: number;
  reasonPhrase?: string;
}

export class Cookie {
  name?: string;
  value?: string;
  version?: number;
  path?: string;
  domain?: string;
}

export class NewCookie extends Cookie {
  comment?: string;
  maxAge?: number;
  expiry?: Date;
  secure?: boolean;
  httpOnly?: boolean;
}

export class EntityTag {
  value?: string;
  weak?: boolean;
}

export class Link {
  rel?: string;
  rels?: string[];
  uriBuilder?: UriBuilder;
  uri?: URI;
  params?: { [index: string]: string };
  type?: string;
  title?: string;
}

export interface AutoCloseable {
}

export class AdresseDto {
  ligne1?: string;
  ligne2?: string;
  ligne3?: string;
  codePostal?: string;
  ville?: string;
  pays?: string;
}

export class CorrespondantDto implements Dto {
  code?: string;
  nom?: string;
  tags?: string[];
}

export class Correspondant {
  code?: string;
  nom?: string;
  tags?: string[];
  dateDesactivation?: any;
  metadata?: { [index: string]: any };
}

export class UriBuilder {
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a été ajouté avec succès
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
  }
}

@Injectable()
export class INotificationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/clean
   * Response code 200 - Purges les messages anciens
   * HTTP POST /notification/messages/clean
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.cleanMessages
   */
  cleanMessages(): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`notification/messages/clean`});
  }

  /**
   * messages/count{login : (/.+)?}
   * Response code 200 - Retourne le nombre de message non lues éventuellement filtrés
   * HTTP GET /notification/messages/count{login : (/.+)?}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.countMessageNotificationsUser
   */
  countMessageNotificationsUser(login: string, queryParams?: { canalId?: number; excludedCanalId?: number; canalCode?: string; excludedCanalCode?: string; }): RestResponse<number> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`notification/messages/news/count${login}`,
      queryParams: queryParams
    });
  }

  /**
   * messages/search
   * Response code 200 - Retourne les nombre de nouveautés filtrées
   * HTTP POST /notification/messages/news/count/news/search
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.countSearchedNewMessageNotifications
   */
  countSearchedNewMessageNotifications(arg0: MessageNotificationSearchCriteria): RestResponse<number> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`notification/messages/news/count/search`, data: arg0 });
  }

  /**
   * categorie/create
   * Response code 200 - Retourne le canal créé
   * Response code 500 - Impossible de creer le canal
   * HTTP POST /notification/canal/create
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.createCanalNotification
   */
  createCanalNotification(arg0: SaveCanalNotificationDto): RestResponse<CanalNotificationDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`notification/canal/create`, data: arg0});
  }

  /**
   * message/create
   * Response code 200 - Retourne les messages filtrées
   * HTTP POST /notification/message/create
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.createMessageNotification
   */
  createMessageNotification(arg0: SaveMessageNotificationDto): RestResponse<boolean> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`notification/message/create`, data: arg0});
  }

    /**
     * message/create
     * Response code 200 - Retourne les messages filtrées
     * HTTP POST /notification/message/create
     * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.createMessageNotification
     */
    getListModules(): RestResponse<Array<String>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`notification/modules`});
    }

    /**
     * canal/{id}
     * Response code 204 - Supprime le canal
     * Response code 500 - Impossible de supprimer le canal
     * HTTP DELETE /notification/canal/{id}
     * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.deleteCanalNotification
     */
    deleteCanalNotification(id: number): RestResponse<void> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`notification/canal/${id}` });
    }

  /**
   * notifications/{id}
   * Response code 204 - Supprime la notification
   * Response code 500 - Impossible de supprimer la notification
   * HTTP DELETE /notification/message/{id}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.deleteMessageNotification
   */
  deleteMessageNotification(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`notification/message/${id}`});
  }

  /**
   * canals/actif
   * Response code 200 - Retourne les canaux actifs
   * HTTP GET /notification/canaux/actif
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.findAllActiveCanalNotifications
   */
  findAllActiveCanalNotifications(): RestResponse<CanalNotificationDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/canaux/actif`});
  }

  /**
   * canaux
   * Response code 200 - Retourne les canaux
   * HTTP GET /notification/canaux
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.findAllCanalNotifications
   */
  findAllCanalNotifications(): RestResponse<CanalNotificationWithMessageCountDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/canaux`});
  }

  /**
   * canaux/subscrible
   * Response code 200 - Retourne les canaux avec les informations de souscription
   * HTTP GET /notification/canaux/subscrible
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.findSubscribleCanalNotifications
   */
  findSubscribleCanalNotifications(): RestResponse<CanalNotificationWithSubscribeInformationDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/canaux/subscrible`});
  }

  /**
   * canal/{id}
   * Response code 200 - Retourne un canal
   * Response code 500 - Impossible de retourner le canal
   * HTTP GET /notification/canal/{id}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.getCanalNotification
   */
  getCanalNotification(id: number): RestResponse<CanalNotificationDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/canal/${id}`});
  }

  /**
   * canal/code/{code}
   * Response code 200 - Retourne un canal
   * Response code 500 - Impossible de retourner le canal
   * HTTP GET /notification/canal/code/{code}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.getCanalNotificationByCode
   */
  getCanalNotificationByCode(code: string): RestResponse<CanalNotificationDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/canal/code/${code}`});
  }

  /**
   * message/get/{id}
   * Response code 200 - Retourne le message
   * HTTP POST /notification/message/get/{id}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.getMessageNotification
   */
  getMessageNotification(id: number): RestResponse<MessageNotificationDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`notification/message/get/${id}`});
  }

  /**
   * canal/{id}/markAsRead
   * Response code 204 - Notifications lues
   * Response code 500 - Impossible de mettre au statut lues les notifications
   * HTTP PUT /notification/canal/{id}/markAsRead/{login}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.markAsReadCanal
   */
  markAsReadCanal(id: number, login: string): RestResponse<void> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`notification/canal/${id}/markAsRead/${login}`});
  }

    /**
     * messages/markAsRead/{avecConfirmation}
     * Response code 204 - Notifications lues
     * Response code 500 - Impossible de mettre au statut lues les notifications
     * HTTP PUT /notification/messages/markAsRead/{avecConfirmation}
     * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.markAsReadMessageNotifications
     */
    markAsReadMessageNotifications(avecConfirmation: boolean, arg1: IdsDto): RestResponse<number> {
      return this.httpClient.request({ method: 'PUT', url: uriEncoding`notification/messages/markAsRead/${avecConfirmation}`, data: arg1 });
    }


  /**
   * messages/{login}/markAllAsReadUser/{avecConfirmation}
   * Response code 204 - Notifications lues
   * Response code 500 - Impossible de mettre au statut lues les notifications
   * HTTP PUT /notification/messages/{login}/markAllAsReadUser/{avecConfirmation}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.markAllAsReadMessageNotifications
   */
    markAllAsReadMessageNotifications(avecConfirmation: boolean, login : string): RestResponse<number> {
      return this.httpClient.request({ method: 'PUT', url: uriEncoding`notification/messages/${login}/markAllAsReadUser/${avecConfirmation}`});
    }

  /**
   * messages/search
   * Response code 200 - Retourne les messages filtrées
   * HTTP POST /notification/messages/search
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.searchMessageNotifications
   */
  searchMessageNotifications(arg0: MessageNotificationSearchCriteria): RestResponse<PaginationResult<MessageNotificationLightDto>> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`notification/messages/search`, data: arg0});
  }

  /**
   * canal/subscribe/{id}
   * Response code 200 - Retourne vrai si la souscription a été réalisée
   * HTTP PUT /notification/canal/subscribe/{id}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.subscribeToCanalNotification
   */
  subscribeToCanalNotification(id: number): RestResponse<boolean> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`notification/canal/subscribe/${id}`});
  }

  /**
   * canal/unsubscribe/{id}
   * Response code 200 - Retourne vrai si la désinscription a été réalisée
   * HTTP PUT /notification/canal/unsubscribe/{id}
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.unsubscribeToCanalNotification
   */
  unsubscribeToCanalNotification(id: number): RestResponse<boolean> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`notification/canal/unsubscribe/${id}`});
  }

    /**
     * categorie/update
     * Response code 200 - Retourne le canal modifié
     * Response code 500 - Impossible de modifier le canal
     * HTTP PUT /notification/canal/update/{id}
     * Java method: fr.cerba.digicerba.notifications.webservices.notification.INotificationsWebService.updateCanalNotification
     */
    updateCanalNotification(id: number, arg1: SaveCanalNotificationDto): RestResponse<CanalNotificationDto> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`notification/canal/update/${id}`, data: arg1 });
    }


}

@Injectable()
export class ITagsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /tags/adminEnabled
   * Java method: fr.cerba.digicerba.notifications.webservices.notification.ITagsWebService.getAccessAdminAuthorization
   */
  getAccessAdminAuthorization(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`tags/adminEnabled`});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia récupérée avec succès
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne à la récupération du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getAllTags
   */
  getAllTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags/all`});
  }

  /**
   * /
   * Response code 200 - Retourne le détail des infos d'un correspondant
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succès
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs pour une catégorie
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /technic/tags/byCategorie
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTagsByCategorie
   */
  getTagsByCategorie(queryParams?: { locale?: string; categorie?: string; }): RestResponse<string[]> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`technic/tags/byCategorie`,
      queryParams: queryParams
    });
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succès
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
  }
}

export type RestResponse<R> = Observable<R>;

export type TypeDiffusionEnum = 'TOUS' | 'TAG';

export type TypeAutorisationEnum = 'PUBLIC' | 'CORRESPONDANT';

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type MessageNotificationTriEnum = 'TITRE' | 'CANAL_NOM' | 'DATE_PUPLICATION' | 'READ';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/notifications/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/common/resources/resources.ts